import entity from '../../../models/services/serviceOrders'

export default [
  {
    path: '/service-orders',
    meta: {
      entity,
      requiresPermissionTo: 'serviceOrders',
      crud: 'list'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/service-orders/new',
    meta: {
      entity,
      requiresPermissionTo: 'serviceOrders',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/service-orders/:id',
    meta: {
      entity,
      requiresPermissionTo: 'serviceOrders',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  }
]
